import { render, staticRenderFns } from "./sale-by-serial.vue?vue&type=template&id=b8bedce2&scoped=true&"
import script from "./sale-by-serial.vue?vue&type=script&lang=js&"
export * from "./sale-by-serial.vue?vue&type=script&lang=js&"
import style0 from "./sale-by-serial.vue?vue&type=style&index=0&id=b8bedce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bedce2",
  null
  
)

export default component.exports